<template>
  <div 
    id="fresh_water_intake_ship"
    class="fresh_water_intake"
  >
    <div 
      v-if="receivedData"
      class="fresh_water_intake-item"
    >
      <CastomGraphic
          :received-data="receivedData[0]"
          graph-type="bar"
          index-axis="y"
          :id="'fresh_water_intake_ship-1'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>  
    <div 
      v-if="receivedData"
      class="fresh_water_intake-item"
    >
      <CastomGraphic
          :received-data="receivedData[1]"
          graph-type="bar"
          index-axis="y"
          :id="'fresh_water_intake_ship-2'"
          :aspect-ratio="1"
          :maintain-aspect-ratio="true"
      />
    </div>  
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'

export default {
  name: 'FreshWaterIntake',
  
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'fresh_water_intake',
      cloneElementId: 'fresh_water_intake_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '62,63').then((response) => {
        this.receivedData = response.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .fresh_water_intake {
    display: flex;

    &-item {
      width: 50%;
    }
  }
</style>